import { render } from "./KpiChat.vue?vue&type=template&id=352e54d2&scoped=true"
import script from "./KpiChat.vue?vue&type=script&lang=js"
export * from "./KpiChat.vue?vue&type=script&lang=js"

import "./KpiChat.vue?vue&type=style&index=0&id=352e54d2&lang=scss&scoped=true"

import exportComponent from "/Users/emmanueledurante/Documents/Lavoro/Martech/whappy-app-front-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-352e54d2"]])

export default __exports__